<template>
  <div>
    <BpmnEditorComponents v-model="sheet_id" />
  </div>
</template>
<script>
import BpmnEditorComponents from "./BpmnEditorComponents";

export default {
  name: 'BpmnEditor',
  components: {BpmnEditorComponents },
  data () {
    return {
      sheet_id:0,
    }
  },
  mounted () {
  },
  activated() {
    if(this.$route.query.id){
      this.sheet_id=this.$route.query.id;
    }
  },
  watch:{
    sheet_id(n,o){
      console.log(n,o)
    }
  }
}
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/BpmnEditor.vue